import { render, staticRenderFns } from "./auction_room.vue?vue&type=template&id=d0544bf4&scoped=true"
import script from "./auction_room.vue?vue&type=script&lang=js"
export * from "./auction_room.vue?vue&type=script&lang=js"
import style0 from "./auction_room.vue?vue&type=style&index=0&id=d0544bf4&prod&lang=css&scoped=true"
import style1 from "./auction_room.vue?vue&type=style&index=1&id=d0544bf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0544bf4",
  null
  
)

export default component.exports